//imported
import * as Path from "routes/paths";

const useModules = () => {
  let modules = [
    /******Dashboard********** */
    {
      url: Path.dashboard,
      model_name: "dashboard",
      name: "Dashboard",
      //   sidebar_icon: "fas fa-fire",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
        >
          <path
            d="M7.83279 6.6882H1.58279C0.778652 6.6882 0.124512 6.03406 0.124512 5.22977V1.47977C0.124512 0.675625 0.778652 0.0214844 1.58279 0.0214844H7.83279C8.63709 0.0214844 9.29123 0.675625 9.29123 1.47977V5.22977C9.29123 6.03406 8.63709 6.6882 7.83279 6.6882ZM1.58279 1.27148C1.52757 1.27153 1.47461 1.29348 1.43556 1.33253C1.39651 1.37159 1.37455 1.42454 1.37451 1.47977V5.22977C1.37452 5.28502 1.39646 5.338 1.43552 5.37709C1.47457 5.41617 1.52754 5.43815 1.58279 5.4382H7.83279C7.88807 5.43818 7.94107 5.41622 7.98016 5.37713C8.01924 5.33805 8.04121 5.28504 8.04123 5.22977V1.47977C8.04118 1.42451 8.0192 1.37154 7.98011 1.33249C7.94103 1.29344 7.88804 1.27149 7.83279 1.27148H1.58279ZM7.83279 20.0215H1.58279C0.778652 20.0215 0.124512 19.3673 0.124512 18.5632V9.8132C0.124512 9.00891 0.778652 8.35477 1.58279 8.35477H7.83279C8.63709 8.35477 9.29123 9.00891 9.29123 9.8132V18.5632C9.29123 19.3673 8.63709 20.0215 7.83279 20.0215ZM1.58279 9.60477C1.52754 9.60482 1.47457 9.6268 1.43552 9.66588C1.39646 9.70497 1.37452 9.75795 1.37451 9.8132V18.5632C1.37455 18.6184 1.39651 18.6714 1.43556 18.7104C1.47461 18.7495 1.52757 18.7714 1.58279 18.7715H7.83279C7.88804 18.7715 7.94103 18.7495 7.98011 18.7105C8.0192 18.6714 8.04118 18.6185 8.04123 18.5632V9.8132C8.04121 9.75793 8.01924 9.70492 7.98016 9.66584C7.94107 9.62675 7.88807 9.60479 7.83279 9.60477H1.58279ZM18.6662 20.0215H12.4162C11.6119 20.0215 10.9578 19.3673 10.9578 18.5632V14.8132C10.9578 14.0089 11.6119 13.3548 12.4162 13.3548H18.6662C19.4704 13.3548 20.1245 14.0089 20.1245 14.8132V18.5632C20.1245 19.3673 19.4704 20.0215 18.6662 20.0215ZM12.4162 14.6048C12.361 14.6048 12.308 14.6268 12.2689 14.6658C12.2298 14.7049 12.2078 14.7579 12.2078 14.8132V18.5632C12.2078 18.6185 12.2298 18.6714 12.2689 18.7105C12.308 18.7495 12.361 18.7715 12.4162 18.7715H18.6662C18.7215 18.7714 18.7744 18.7495 18.8135 18.7104C18.8525 18.6714 18.8745 18.6184 18.8745 18.5632V14.8132C18.8745 14.758 18.8526 14.705 18.8135 14.6659C18.7745 14.6268 18.7215 14.6048 18.6662 14.6048H12.4162ZM18.6662 11.6882H12.4162C11.6119 11.6882 10.9578 11.0341 10.9578 10.2298V1.47977C10.9578 0.675625 11.6119 0.0214844 12.4162 0.0214844H18.6662C19.4704 0.0214844 20.1245 0.675625 20.1245 1.47977V10.2298C20.1245 11.0341 19.4704 11.6882 18.6662 11.6882ZM12.4162 1.27148C12.361 1.27149 12.308 1.29344 12.2689 1.33249C12.2298 1.37154 12.2078 1.42451 12.2078 1.47977V10.2298C12.2078 10.285 12.2298 10.338 12.2689 10.3771C12.308 10.4162 12.361 10.4382 12.4162 10.4382H18.6662C18.7215 10.4382 18.7745 10.4162 18.8135 10.3771C18.8526 10.338 18.8745 10.285 18.8745 10.2298V1.47977C18.8745 1.42454 18.8525 1.37159 18.8135 1.33253C18.7744 1.29348 18.7215 1.27153 18.6662 1.27148H12.4162Z"
            fill="white"
          ></path>
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: false,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {},
    },
    /**************Manage Practitioners*********/
    {
      url: Path.practitioner,
      model_name: "users",
      name: "Manage Practitioners",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M16 17.0001V19.0001H2V17.0001C2 17.0001 2 13.0001 9 13.0001C16 13.0001 16 17.0001 16 17.0001ZM12.5 7.50005C12.5 6.80782 12.2947 6.13113 11.9101 5.55556C11.5256 4.97998 10.9789 4.53138 10.3394 4.26647C9.69985 4.00157 8.99612 3.93226 8.31718 4.0673C7.63825 4.20235 7.01461 4.5357 6.52513 5.02518C6.03564 5.51466 5.7023 6.1383 5.56725 6.81724C5.4322 7.49617 5.50152 8.1999 5.76642 8.83944C6.03133 9.47899 6.47993 10.0256 7.0555 10.4102C7.63108 10.7948 8.30777 11.0001 9 11.0001C9.92826 11.0001 10.8185 10.6313 11.4749 9.97493C12.1313 9.31855 12.5 8.42831 12.5 7.50005ZM15.94 13.0001C16.5547 13.4758 17.0578 14.0805 17.4137 14.7716C17.7696 15.4626 17.9697 16.2233 18 17.0001V19.0001H22V17.0001C22 17.0001 22 13.3701 15.94 13.0001ZM15 4.00005C14.3117 3.99622 13.6385 4.20201 13.07 4.59005C13.6774 5.43879 14.0041 6.45634 14.0041 7.50005C14.0041 8.54377 13.6774 9.56132 13.07 10.4101C13.6385 10.7981 14.3117 11.0039 15 11.0001C15.9283 11.0001 16.8185 10.6313 17.4749 9.97493C18.1313 9.31855 18.5 8.42831 18.5 7.50005C18.5 6.57179 18.1313 5.68156 17.4749 5.02518C16.8185 4.3688 15.9283 4.00005 15 4.00005Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.practitioner_add,
        edit: Path.practitioneredit,
        view: Path.practitionerview,
      },
    },

    /****manage clients *********/
    {
      url: Path.manageClients,
      model_name: "clients",
      name: "Manage Clients",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
        >
          <g clip-path="url(#clip0_175_315)">
            <path
              d="M10.5 11.375C11.4283 11.375 12.3185 11.0062 12.9749 10.3499C13.6313 9.6935 14 8.80326 14 7.875C14 6.94674 13.6313 6.0565 12.9749 5.40013C12.3185 4.74375 11.4283 4.375 10.5 4.375C9.57174 4.375 8.6815 4.74375 8.02513 5.40013C7.36875 6.0565 7 6.94674 7 7.875C7 8.80326 7.36875 9.6935 8.02513 10.3499C8.6815 11.0062 9.57174 11.375 10.5 11.375ZM10.5 11.375C9.10761 11.375 7.77226 11.9281 6.78769 12.9127C5.80312 13.8973 5.25 15.2326 5.25 16.625V19.25M10.5 11.375C11.8924 11.375 13.2277 11.9281 14.2123 12.9127C15.1969 13.8973 15.75 15.2326 15.75 16.625V19.25M11.375 4.375C11.7285 2.919 13.1381 1.75 14.875 1.75C16.7755 1.75 18.3575 3.31625 18.375 5.25C18.3575 7.18375 16.7755 8.75 14.875 8.75M14.875 8.75H14M14.875 8.75C17.752 8.75 20.125 11.1002 20.125 14V15.75M9.625 4.375C9.2715 2.919 7.86188 1.75 6.125 1.75C4.2245 1.75 2.6425 3.31625 2.625 5.25C2.6425 7.18375 4.2245 8.75 6.125 8.75M6.125 8.75H7M6.125 8.75C3.248 8.75 0.875 11.1002 0.875 14V15.75"
              stroke="white"
              stroke-width="2"
            />
          </g>
          <defs>
            <clipPath id="clip0_175_315">
              <rect width="21" height="21" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {},
    },

    /**************Category *********/
    {
      url: Path.category,
      model_name: "categories",
      name: "Categories",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
        >
          <path
            d="M17.8389 1.89209C17.4131 1.46545 16.847 1.23047 16.2446 1.23047H15.2271V1.02539C15.2271 0.45999 14.7671 0 14.2017 0H6.81885C6.25345 0 5.79346 0.45999 5.79346 1.02539V1.23047H4.77229C3.53112 1.23047 2.52021 2.24134 2.51881 3.48383L2.50195 18.7416C2.5013 19.3447 2.73537 19.9117 3.16108 20.3384C3.58682 20.765 4.15304 21 4.75543 21H16.2277C17.4689 21 18.4798 19.9891 18.4812 18.7466L18.498 3.48883C18.4987 2.88578 18.2646 2.3187 17.8389 1.89209ZM7.02393 1.23047H13.9966V2.46094H7.02393V1.23047ZM17.252 18.7452C17.2513 19.3101 16.7918 19.7695 16.2277 19.7695H4.75543C4.48161 19.7695 4.22424 19.6627 4.03073 19.4688C3.83722 19.2748 3.73082 19.0171 3.73111 18.743L3.74797 3.48522C3.74858 2.92039 4.20808 2.46094 4.77229 2.46094H5.79346V2.66602C5.79346 3.23142 6.25345 3.69141 6.81885 3.69141H14.2017C14.7671 3.69141 15.2271 3.23142 15.2271 2.66602V2.46094H16.2446C16.5184 2.46094 16.7758 2.56774 16.9693 2.76166C17.1628 2.95559 17.2692 3.21337 17.2689 3.48744L17.252 18.7452Z"
            fill="white"
          />
          <path
            d="M10.7091 8.20305H15.0802C15.42 8.20305 15.6954 7.92759 15.6954 7.58782C15.6954 7.24805 15.42 6.97259 15.0802 6.97259H10.7091C10.3693 6.97259 10.0939 7.24805 10.0939 7.58782C10.0939 7.92759 10.3693 8.20305 10.7091 8.20305ZM10.7091 12.3046H15.0802C15.42 12.3046 15.6954 12.0292 15.6954 11.6894C15.6954 11.3496 15.42 11.0741 15.0802 11.0741H10.7091C10.3693 11.0741 10.0939 11.3496 10.0939 11.6894C10.0939 12.0292 10.3693 12.3046 10.7091 12.3046ZM15.0978 15.1757H10.7091C10.3693 15.1757 10.0939 15.4512 10.0939 15.7909C10.0939 16.1307 10.3693 16.4062 10.7091 16.4062H15.0978C15.4376 16.4062 15.713 16.1307 15.713 15.7909C15.713 15.4512 15.4376 15.1757 15.0978 15.1757ZM8.09056 5.91262L6.67175 7.33143L6.33722 6.99687C6.09695 6.7566 5.70743 6.7566 5.46716 6.99687C5.22689 7.2371 5.22689 7.62666 5.46716 7.86693L6.23673 8.63655C6.35211 8.75192 6.5086 8.81674 6.67177 8.81674C6.83494 8.81674 6.99142 8.75192 7.1068 8.63655L8.96066 6.78272C9.20093 6.5425 9.20093 6.15293 8.96066 5.91266C8.7204 5.67235 8.33087 5.67235 8.09056 5.91262ZM8.09056 10.3274L6.67175 11.7462L6.33722 11.4117C6.09695 11.1714 5.70743 11.1714 5.46716 11.4117C5.22689 11.6519 5.22689 12.0415 5.46716 12.2818L6.23673 13.0514C6.35211 13.1668 6.5086 13.2316 6.67177 13.2316C6.83494 13.2316 6.99142 13.1668 7.1068 13.0514L8.96066 11.1975C9.20093 10.9573 9.20093 10.5677 8.96066 10.3275C8.7204 10.0872 8.33083 10.0872 8.09056 10.3274ZM8.09056 14.429L6.67175 15.8478L6.33722 15.5133C6.09695 15.273 5.70743 15.273 5.46716 15.5133C5.22689 15.7535 5.22689 16.143 5.46716 16.3833L6.23673 17.1529C6.35211 17.2683 6.5086 17.3331 6.67177 17.3331C6.83494 17.3331 6.99142 17.2683 7.1068 17.1529L8.96066 15.2991C9.20093 15.0589 9.20093 14.6693 8.96066 14.429C8.7204 14.1888 8.33083 14.1888 8.09056 14.429Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-list",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.category_add,
        edit: Path.categoryedit,
        view: Path.categoryview,
      },
    },
    /**************Subcategory *********/
    {
      url: Path.subcategory,
      model_name: "subcategories",
      name: "SubCategories",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
        >
          <path
            d="M17.7188 14.53V11.8125C17.7188 11.4644 17.5805 11.1306 17.3343 10.8844C17.0882 10.6383 16.7544 10.5 16.4063 10.5H11.1563V7.875H12.4688C12.8167 7.87465 13.1504 7.73626 13.3965 7.49019C13.6425 7.24413 13.7809 6.91049 13.7813 6.5625V2.625C13.7809 2.27701 13.6425 1.94337 13.3965 1.69731C13.1504 1.45124 12.8167 1.31285 12.4688 1.3125H8.53126C8.18327 1.31285 7.84963 1.45124 7.60356 1.69731C7.3575 1.94337 7.2191 2.27701 7.21876 2.625V6.5625C7.2191 6.91049 7.3575 7.24413 7.60356 7.49019C7.84963 7.73626 8.18327 7.87465 8.53126 7.875H9.84376V10.5H4.59376C4.24566 10.5 3.91182 10.6383 3.66568 10.8844C3.41954 11.1306 3.28126 11.4644 3.28126 11.8125V14.5307C2.66264 14.6904 2.12351 15.0703 1.76492 15.5991C1.40634 16.1279 1.25292 16.7693 1.33343 17.4031C1.41393 18.0369 1.72283 18.6196 2.20223 19.042C2.68162 19.4643 3.2986 19.6973 3.93751 19.6973C4.57641 19.6973 5.19339 19.4643 5.67278 19.042C6.15218 18.6196 6.46108 18.0369 6.54158 17.4031C6.62209 16.7693 6.46867 16.1279 6.11009 15.5991C5.75151 15.0703 5.21238 14.6904 4.59376 14.5307V11.8125H9.84376V14.5307C9.22514 14.6904 8.68601 15.0703 8.32742 15.5991C7.96884 16.1279 7.81542 16.7693 7.89593 17.4031C7.97643 18.0369 8.28533 18.6196 8.76473 19.042C9.24412 19.4643 9.8611 19.6973 10.5 19.6973C11.1389 19.6973 11.7559 19.4643 12.2353 19.042C12.7147 18.6196 13.0236 18.0369 13.1041 17.4031C13.1846 16.7693 13.0312 16.1279 12.6726 15.5991C12.314 15.0703 11.7749 14.6904 11.1563 14.5307V11.8125H16.4063V14.53C15.7876 14.6898 15.2485 15.0696 14.8899 15.5984C14.5313 16.1272 14.3779 16.7686 14.4584 17.4024C14.5389 18.0363 14.8478 18.619 15.3272 19.0413C15.8066 19.4637 16.4236 19.6967 17.0625 19.6967C17.7014 19.6967 18.3184 19.4637 18.7978 19.0413C19.2772 18.619 19.5861 18.0363 19.6666 17.4024C19.7471 16.7686 19.5937 16.1272 19.2351 15.5984C18.8765 15.0696 18.3374 14.6898 17.7188 14.53ZM8.53126 2.625H12.4688L12.4694 6.5625H8.53126V2.625ZM5.25001 17.0625C5.25001 17.3221 5.17303 17.5758 5.02881 17.7917C4.88459 18.0075 4.67961 18.1758 4.43978 18.2751C4.19995 18.3744 3.93605 18.4004 3.68145 18.3498C3.42685 18.2991 3.19298 18.1741 3.00943 17.9906C2.82587 17.807 2.70087 17.5732 2.65023 17.3186C2.59958 17.064 2.62557 16.8001 2.72491 16.5602C2.82425 16.3204 2.99248 16.1154 3.20832 15.9712C3.42416 15.827 3.67792 15.75 3.93751 15.75C4.2855 15.7503 4.61913 15.8887 4.8652 16.1348C5.11127 16.3809 5.24966 16.7145 5.25001 17.0625ZM11.8125 17.0625C11.8125 17.3221 11.7355 17.5758 11.5913 17.7917C11.4471 18.0075 11.2421 18.1758 11.0023 18.2751C10.7625 18.3744 10.4986 18.4004 10.244 18.3498C9.98935 18.2991 9.75549 18.1741 9.57193 17.9906C9.38837 17.807 9.26337 17.5732 9.21273 17.3186C9.16208 17.064 9.18807 16.8001 9.28741 16.5602C9.38675 16.3204 9.55498 16.1154 9.77082 15.9712C9.98666 15.827 10.2404 15.75 10.5 15.75C10.8479 15.7505 11.1815 15.889 11.4275 16.135C11.6735 16.381 11.812 16.7146 11.8125 17.0625ZM17.0625 18.375C16.8029 18.375 16.5492 18.298 16.3333 18.1538C16.1175 18.0096 15.9493 17.8046 15.8499 17.5648C15.7506 17.3249 15.7246 17.061 15.7752 16.8064C15.8259 16.5518 15.9509 16.318 16.1344 16.1344C16.318 15.9509 16.5519 15.8259 16.8065 15.7752C17.0611 15.7246 17.325 15.7506 17.5648 15.8499C17.8046 15.9492 18.0096 16.1175 18.1538 16.3333C18.298 16.5492 18.375 16.8029 18.375 17.0625C18.3747 17.4105 18.2363 17.7441 17.9902 17.9902C17.7441 18.2363 17.4105 18.3747 17.0625 18.375Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-list",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.subcategory_add,
        edit: Path.subcategoryedit,
        view: Path.subcategoryview,
      },
    },
    /**************Resources *********/
    {
      url: Path.resource,
      model_name: "resources",
      name: "Resources",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M16.5 10.25L21 12.5L12 17L3 12.5L7.5 10.25M16.5 15.25L21 17.5L12 22L3 17.5L7.5 15.25M12 3L21 7.5L12 12L3 7.5L12 3Z"
            stroke="white"
            stroke-width="2"
          />
        </svg>
      ),
      icon: "far fa fa-list",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.resource_add,
        edit: Path.resourceedit,
        view: Path.resourceview,
      },
    },
    /**************Client category form *********/
    // {
    //   url: Path.client_category_form,
    //   model_name: "admin_settings",
    //   name: "Client Category Form",
    //   sidebar_icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //     >
    //       <path
    //         d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H12.022C11.7223 20.5325 11.484 20.0284 11.313 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V11.313C20.0284 11.484 20.5325 11.7223 21 12.022V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM17.5 11C17.652 11 17.802 11.005 17.952 11.015C17.9951 10.9015 18.01 10.7791 17.9953 10.6586C17.9807 10.538 17.9369 10.4228 17.8678 10.3229C17.7988 10.2231 17.7064 10.1415 17.5988 10.0852C17.4912 10.0289 17.3715 9.9997 17.25 10H12.75C12.5511 10 12.3603 10.079 12.2197 10.2197C12.079 10.3603 12 10.5511 12 10.75C12 10.9489 12.079 11.1397 12.2197 11.2803C12.3603 11.421 12.5511 11.5 12.75 11.5H14.996C15.7892 11.1689 16.6404 10.9989 17.5 11ZM6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75ZM6 10.75C6 10.4545 6.0582 10.1619 6.17127 9.88896C6.28434 9.61598 6.45008 9.36794 6.65901 9.15901C6.86794 8.95008 7.11598 8.78434 7.38896 8.67127C7.66194 8.5582 7.95453 8.5 8.25 8.5C8.54547 8.5 8.83806 8.5582 9.11104 8.67127C9.38402 8.78434 9.63206 8.95008 9.84099 9.15901C10.0499 9.36794 10.2157 9.61598 10.3287 9.88896C10.4418 10.1619 10.5 10.4545 10.5 10.75C10.5 11.3467 10.2629 11.919 9.84099 12.341C9.41903 12.7629 8.84674 13 8.25 13C7.65326 13 7.08097 12.7629 6.65901 12.341C6.23705 11.919 6 11.3467 6 10.75ZM8.25 10C8.05109 10 7.86032 10.079 7.71967 10.2197C7.57902 10.3603 7.5 10.5511 7.5 10.75C7.5 10.9489 7.57902 11.1397 7.71967 11.2803C7.86032 11.421 8.05109 11.5 8.25 11.5C8.44891 11.5 8.63968 11.421 8.78033 11.2803C8.92098 11.1397 9 10.9489 9 10.75C9 10.5511 8.92098 10.3603 8.78033 10.2197C8.63968 10.079 8.44891 10 8.25 10ZM8.25 14C7.65326 14 7.08097 14.2371 6.65901 14.659C6.23705 15.081 6 15.6533 6 16.25C6 16.8467 6.23705 17.419 6.65901 17.841C7.08097 18.2629 7.65326 18.5 8.25 18.5C8.84674 18.5 9.41903 18.2629 9.84099 17.841C10.2629 17.419 10.5 16.8467 10.5 16.25C10.5 15.6533 10.2629 15.081 9.84099 14.659C9.41903 14.2371 8.84674 14 8.25 14ZM7.5 16.25C7.5 16.0511 7.57902 15.8603 7.71967 15.7197C7.86032 15.579 8.05109 15.5 8.25 15.5C8.44891 15.5 8.63968 15.579 8.78033 15.7197C8.92098 15.8603 9 16.0511 9 16.25C9 16.4489 8.92098 16.6397 8.78033 16.7803C8.63968 16.921 8.44891 17 8.25 17C8.05109 17 7.86032 16.921 7.71967 16.7803C7.57902 16.6397 7.5 16.4489 7.5 16.25ZM23 17.5C23 16.0413 22.4205 14.6424 21.3891 13.6109C20.3576 12.5795 18.9587 12 17.5 12C16.0413 12 14.6424 12.5795 13.6109 13.6109C12.5795 14.6424 12 16.0413 12 17.5C12 18.9587 12.5795 20.3576 13.6109 21.3891C14.6424 22.4205 16.0413 23 17.5 23C18.9587 23 20.3576 22.4205 21.3891 21.3891C22.4205 20.3576 23 18.9587 23 17.5ZM18 18L18.001 20.503C18.001 20.6356 17.9483 20.7628 17.8546 20.8566C17.7608 20.9503 17.6336 21.003 17.501 21.003C17.3684 21.003 17.2412 20.9503 17.1474 20.8566C17.0537 20.7628 17.001 20.6356 17.001 20.503V18H14.496C14.3634 18 14.2362 17.9473 14.1424 17.8536C14.0487 17.7598 13.996 17.6326 13.996 17.5C13.996 17.3674 14.0487 17.2402 14.1424 17.1464C14.2362 17.0527 14.3634 17 14.496 17H17V14.5C17 14.3674 17.0527 14.2402 17.1464 14.1464C17.2402 14.0527 17.3674 14 17.5 14C17.6326 14 17.7598 14.0527 17.8536 14.1464C17.9473 14.2402 18 14.3674 18 14.5V17H20.497C20.6296 17 20.7568 17.0527 20.8506 17.1464C20.9443 17.2402 20.997 17.3674 20.997 17.5C20.997 17.6326 20.9443 17.7598 20.8506 17.8536C20.7568 17.9473 20.6296 18 20.497 18H18Z"
    //         fill="white"
    //       />
    //     </svg>
    //   ),
    //   icon: "far fa fa-list",
    //   dashboard: false,
    //   is_modules: true,
    //   is_permission: true,
    //   is_sidebar: true,
    //   is_dropdown: false,
    //   is_open: false,
    //   count: 0,
    //   sub_modules: {},
    // },

    {
      url: Path.form_management_listing,
      model_name: "form_management",
      name: "Form Management",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
        >
          <path
            d="M17.8389 1.89209C17.4131 1.46545 16.847 1.23047 16.2446 1.23047H15.2271V1.02539C15.2271 0.45999 14.7671 0 14.2017 0H6.81885C6.25345 0 5.79346 0.45999 5.79346 1.02539V1.23047H4.77229C3.53112 1.23047 2.52021 2.24134 2.51881 3.48383L2.50195 18.7416C2.5013 19.3447 2.73537 19.9117 3.16108 20.3384C3.58682 20.765 4.15304 21 4.75543 21H16.2277C17.4689 21 18.4798 19.9891 18.4812 18.7466L18.498 3.48883C18.4987 2.88578 18.2646 2.3187 17.8389 1.89209ZM7.02393 1.23047H13.9966V2.46094H7.02393V1.23047ZM17.252 18.7452C17.2513 19.3101 16.7918 19.7695 16.2277 19.7695H4.75543C4.48161 19.7695 4.22424 19.6627 4.03073 19.4688C3.83722 19.2748 3.73082 19.0171 3.73111 18.743L3.74797 3.48522C3.74858 2.92039 4.20808 2.46094 4.77229 2.46094H5.79346V2.66602C5.79346 3.23142 6.25345 3.69141 6.81885 3.69141H14.2017C14.7671 3.69141 15.2271 3.23142 15.2271 2.66602V2.46094H16.2446C16.5184 2.46094 16.7758 2.56774 16.9693 2.76166C17.1628 2.95559 17.2692 3.21337 17.2689 3.48744L17.252 18.7452Z"
            fill="white"
          />
          <path
            d="M10.7091 8.20305H15.0802C15.42 8.20305 15.6954 7.92759 15.6954 7.58782C15.6954 7.24805 15.42 6.97259 15.0802 6.97259H10.7091C10.3693 6.97259 10.0939 7.24805 10.0939 7.58782C10.0939 7.92759 10.3693 8.20305 10.7091 8.20305ZM10.7091 12.3046H15.0802C15.42 12.3046 15.6954 12.0292 15.6954 11.6894C15.6954 11.3496 15.42 11.0741 15.0802 11.0741H10.7091C10.3693 11.0741 10.0939 11.3496 10.0939 11.6894C10.0939 12.0292 10.3693 12.3046 10.7091 12.3046ZM15.0978 15.1757H10.7091C10.3693 15.1757 10.0939 15.4512 10.0939 15.7909C10.0939 16.1307 10.3693 16.4062 10.7091 16.4062H15.0978C15.4376 16.4062 15.713 16.1307 15.713 15.7909C15.713 15.4512 15.4376 15.1757 15.0978 15.1757ZM8.09056 5.91262L6.67175 7.33143L6.33722 6.99687C6.09695 6.7566 5.70743 6.7566 5.46716 6.99687C5.22689 7.2371 5.22689 7.62666 5.46716 7.86693L6.23673 8.63655C6.35211 8.75192 6.5086 8.81674 6.67177 8.81674C6.83494 8.81674 6.99142 8.75192 7.1068 8.63655L8.96066 6.78272C9.20093 6.5425 9.20093 6.15293 8.96066 5.91266C8.7204 5.67235 8.33087 5.67235 8.09056 5.91262ZM8.09056 10.3274L6.67175 11.7462L6.33722 11.4117C6.09695 11.1714 5.70743 11.1714 5.46716 11.4117C5.22689 11.6519 5.22689 12.0415 5.46716 12.2818L6.23673 13.0514C6.35211 13.1668 6.5086 13.2316 6.67177 13.2316C6.83494 13.2316 6.99142 13.1668 7.1068 13.0514L8.96066 11.1975C9.20093 10.9573 9.20093 10.5677 8.96066 10.3275C8.7204 10.0872 8.33083 10.0872 8.09056 10.3274ZM8.09056 14.429L6.67175 15.8478L6.33722 15.5133C6.09695 15.273 5.70743 15.273 5.46716 15.5133C5.22689 15.7535 5.22689 16.143 5.46716 16.3833L6.23673 17.1529C6.35211 17.2683 6.5086 17.3331 6.67177 17.3331C6.83494 17.3331 6.99142 17.2683 7.1068 17.1529L8.96066 15.2991C9.20093 15.0589 9.20093 14.6693 8.96066 14.429C8.7204 14.1888 8.33083 14.1888 8.09056 14.429Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: true,
      is_open: false,
      count: 0,
      dropdown_module: [
        {
          url: Path.form_management_listing,
          model_name: "form_management",
          name: "All Forms",
          sidebar_icon: "fas fa-plus",
          icon: "far fa fa-plus",
          dashboard: false,
          is_modules: false,
          is_permission: true,
          is_sidebar: false,
          is_dropdown: false,
          is_open: false,
          count: 0,
          sub_modules: {},
        }
      ]
    },
    /**************Manage Subscriptions*********/
    {
      url: Path.subscriptions,
      model_name: "subscriptions",
      name: "Manage Subscription Plans",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6 19H11V23L8.5 21.5L6 23V19ZM20 1H12V23L14.5 21.5L17 23V21H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19V3C22 2.46957 21.7893 1.96086 21.4142 1.58579C21.0391 1.21071 20.5304 1 20 1ZM14 5H16V7H14V5ZM14 10H16V12H14V10ZM14 15H16V17H14V15ZM4 1C3.47005 1.00158 2.96227 1.2128 2.58753 1.58753C2.2128 1.96227 2.00158 2.47005 2 3V19C2.00158 19.5299 2.2128 20.0377 2.58753 20.4125C2.96227 20.7872 3.47005 20.9984 4 21V3H11V1H4Z"
            fill="white"
          />
          <path
            d="M6 5H8V7H6V5ZM6 10H8V12H6V10ZM6 15H8V17H6V15Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: true,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.subscription_add,
        edit: Path.subscriptionedit,
        view: Path.subscriptionview,
      },
      dropdown_module: [
        {
          url: Path.subscriptions,
          model_name: "subscriptions",
          name: "Manage Subscription Plans",
          sidebar_icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 19H11V23L8.5 21.5L6 23V19ZM20 1H12V23L14.5 21.5L17 23V21H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19V3C22 2.46957 21.7893 1.96086 21.4142 1.58579C21.0391 1.21071 20.5304 1 20 1ZM14 5H16V7H14V5ZM14 10H16V12H14V10ZM14 15H16V17H14V15ZM4 1C3.47005 1.00158 2.96227 1.2128 2.58753 1.58753C2.2128 1.96227 2.00158 2.47005 2 3V19C2.00158 19.5299 2.2128 20.0377 2.58753 20.4125C2.96227 20.7872 3.47005 20.9984 4 21V3H11V1H4Z"
                fill="white"
              />
              <path
                d="M6 5H8V7H6V5ZM6 10H8V12H6V10ZM6 15H8V17H6V15Z"
                fill="white"
              />
            </svg>
          ),
          icon: "far fa fa-user",
          dashboard: false,
          is_modules: false,
          is_permission: true,
        },
        {
          url: Path.storage_plans_management,
          model_name: "storage_plans_management",
          name: "Manage Storage Plans",
          sidebar_icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 19H11V23L8.5 21.5L6 23V19ZM20 1H12V23L14.5 21.5L17 23V21H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19V3C22 2.46957 21.7893 1.96086 21.4142 1.58579C21.0391 1.21071 20.5304 1 20 1ZM14 5H16V7H14V5ZM14 10H16V12H14V10ZM14 15H16V17H14V15ZM4 1C3.47005 1.00158 2.96227 1.2128 2.58753 1.58753C2.2128 1.96227 2.00158 2.47005 2 3V19C2.00158 19.5299 2.2128 20.0377 2.58753 20.4125C2.96227 20.7872 3.47005 20.9984 4 21V3H11V1H4Z"
                fill="white"
              />
              <path
                d="M6 5H8V7H6V5ZM6 10H8V12H6V10ZM6 15H8V17H6V15Z"
                fill="white"
              />
            </svg>
          ),
          icon: "far fa fa-user",
          dashboard: false,
          is_modules: false,
          is_permission: true,
        },
      ],
    },
    /**************Transaction*********/
    {
      url: "#",
      model_name: "transaction",
      name: "Transaction",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M14.5 2.9999C13.837 2.9999 13.2011 3.26329 12.7322 3.73213C12.2634 4.20097 12 4.83685 12 5.4999C12 6.16294 12.2634 6.79882 12.7322 7.26766C13.2011 7.7365 13.837 7.9999 14.5 7.9999C15.163 7.9999 15.7989 7.7365 16.2678 7.26766C16.7366 6.79882 17 6.16294 17 5.4999C17 4.83685 16.7366 4.20097 16.2678 3.73213C15.7989 3.26329 15.163 2.9999 14.5 2.9999ZM10 5.4999C9.99985 4.73395 10.1952 3.98063 10.5676 3.3113C10.94 2.64196 11.477 2.07874 12.1279 1.67499C12.7788 1.27124 13.522 1.0403 14.2871 1.00406C15.0522 0.967824 15.8139 1.12747 16.5 1.4679C17.1861 1.12788 17.9476 0.968552 18.7124 1.00499C19.4773 1.04144 20.2201 1.27244 20.8708 1.67615C21.5214 2.07985 22.0583 2.64291 22.4306 3.31202C22.8029 3.98114 22.9982 4.73419 22.9982 5.4999C22.9982 6.2656 22.8029 7.01865 22.4306 7.68777C22.0583 8.35688 21.5214 8.91994 20.8708 9.32364C20.2201 9.72735 19.4773 9.95835 18.7124 9.9948C17.9476 10.0312 17.1861 9.87191 16.5 9.53189C15.8139 9.87232 15.0522 10.032 14.2871 9.99573C13.522 9.95949 12.7788 9.72856 12.1279 9.3248C11.477 8.92105 10.94 8.35783 10.5676 7.6885C10.1952 7.01916 9.99985 6.26584 10 5.4999ZM18.25 7.9879C18.5976 8.02279 18.9487 7.98444 19.2806 7.87531C19.6124 7.76619 19.9178 7.58871 20.1769 7.35434C20.4359 7.11996 20.643 6.83389 20.7847 6.51456C20.9265 6.19524 20.9997 5.84976 20.9997 5.5004C20.9997 5.15103 20.9265 4.80555 20.7847 4.48623C20.643 4.1669 20.4359 3.88083 20.1769 3.64645C19.9178 3.41208 19.6124 3.2346 19.2806 3.12548C18.9487 3.01636 18.5976 2.978 18.25 3.0129C18.7401 3.74963 19.0011 4.61502 19 5.4999C19.0013 6.38511 18.7403 7.25087 18.25 7.9879ZM8.435 13.2499C8.27081 13.2495 8.10814 13.2814 7.95629 13.3439C7.80444 13.4063 7.66638 13.4981 7.55 13.6139L5.5 15.6639V19.4999H11.127L16.93 18.0499L20.462 16.5419C20.5823 16.4769 20.6744 16.3697 20.7205 16.241C20.7667 16.1123 20.7637 15.9711 20.7122 15.8444C20.6606 15.7177 20.5641 15.6146 20.4412 15.5547C20.3182 15.4948 20.1775 15.4824 20.046 15.5199L20.026 15.5249L13.614 16.9999H10V14.9999H13.125C13.3571 14.9999 13.5796 14.9077 13.7437 14.7436C13.9078 14.5795 14 14.357 14 14.1249C14 13.8928 13.9078 13.6703 13.7437 13.5062C13.5796 13.3421 13.3571 13.2499 13.125 13.2499H8.435ZM15.987 14.4019L19.539 13.5849C19.9173 13.4854 20.3134 13.474 20.6968 13.5514C21.0802 13.6288 21.4408 13.7931 21.7509 14.0316C22.0609 14.2701 22.3122 14.5765 22.4854 14.9272C22.6586 15.278 22.7491 15.6637 22.75 16.0549C22.7499 16.5298 22.6176 16.9953 22.3679 17.3993C22.1181 17.8032 21.7608 18.1296 21.336 18.3419L21.309 18.3559L17.569 19.9509L11.373 21.4999H0V14.2499H4.086L6.138 12.1979C6.44034 11.8966 6.79907 11.6578 7.1937 11.4951C7.58834 11.3325 8.01116 11.2491 8.438 11.2499H13.125C13.5259 11.2498 13.9225 11.3337 14.2891 11.4959C14.6557 11.6582 14.9843 11.8954 15.2539 12.1922C15.5234 12.4891 15.7278 12.839 15.8541 13.2195C15.9804 13.6001 16.0256 14.0028 15.987 14.4019ZM3.5 16.2499H2V19.4999H3.5V16.2499Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: false,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: true,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.earning,
        edit: Path.subscription_history,
      },
      dropdown_module: [
        {
          url: Path.earning,
          model_name: "earning",
          name: "Earning",
          sidebar_icon: "fas fa-fire",
          icon: "far fa fa-user",
          dashboard: false,
          is_modules: false,
          is_permission: true,
          is_sidebar: false,
          is_dropdown: false,
          is_open: false,
          count: 0,
          sub_modules: {},
        },
        {
          url: Path.subscription_history,
          model_name: "subscription_history",
          name: "Subscription Sales",
          sidebar_icon: "fas fa-fire",
          icon: "far fa fa-user",
          dashboard: false,
          is_modules: false,
          is_permission: true,
          is_sidebar: false,
          is_dropdown: false,
          is_open: false,
          count: 0,
          sub_modules: {},
        },
      ],
    },

    /**************FAQ*********/
    {
      url: Path.faq,
      model_name: "faq",
      name: "FAQ",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18 15H6L2 19V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H18C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V14C19 14.2652 18.8946 14.5196 18.7071 14.7071C18.5196 14.8946 18.2652 15 18 15ZM23 9V23L19 19H8C7.73478 19 7.48043 18.8946 7.29289 18.7071C7.10536 18.5196 7 18.2652 7 18V17H21V8H22C22.2652 8 22.5196 8.10536 22.7071 8.29289C22.8946 8.48043 23 8.73478 23 9ZM8.19 4C7.32 4 6.62 4.2 6.08 4.59C5.56 5 5.3 5.57 5.31 6.36L5.32 6.39H7.25C7.26 6.09 7.35 5.86 7.53 5.7C7.71517 5.54644 7.9495 5.46479 8.19 5.47C8.5 5.47 8.76 5.57 8.94 5.75C9.12 5.94 9.2 6.2 9.2 6.5C9.2 6.82 9.13 7.09 8.97 7.32C8.83 7.55 8.62 7.75 8.36 7.91C7.85 8.25 7.5 8.55 7.31 8.82C7.11 9.08 7 9.5 7 10H9C9 9.69 9.04 9.44 9.13 9.26C9.22 9.08 9.39 8.9 9.64 8.74C10.09 8.5 10.46 8.21 10.75 7.81C11.04 7.41 11.19 7 11.19 6.5C11.19 5.74 10.92 5.13 10.38 4.68C9.85 4.23 9.12 4 8.19 4ZM7 11V13H9V11H7ZM13 13H15V11H13V13ZM13 4V10H15V4H13Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.faq_add,
        edit: Path.faqedit,
        view: Path.faqview,
      },
    },
    /*************System Access*********/
    {
      url: Path.system_access,
      model_name: "users",
      name: "System Access",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M21 2H15C14.7348 2 14.4804 2.10536 14.2929 2.29289C14.1054 2.48043 14 2.73478 14 3C14 3.26522 14.1054 3.51957 14.2929 3.70711C14.4804 3.89464 14.7348 4 15 4H20V9C20 9.26522 20.1054 9.51957 20.2929 9.70711C20.4804 9.89464 20.7348 10 21 10C21.2652 10 21.5196 9.89464 21.7071 9.70711C21.8946 9.51957 22 9.26522 22 9V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM21 14C20.7348 14 20.4804 14.1054 20.2929 14.2929C20.1054 14.4804 20 14.7348 20 15V20H15C14.7348 20 14.4804 20.1054 14.2929 20.2929C14.1054 20.4804 14 20.7348 14 21C14 21.2652 14.1054 21.5196 14.2929 21.7071C14.4804 21.8946 14.7348 22 15 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V15C22 14.7348 21.8946 14.4804 21.7071 14.2929C21.5196 14.1054 21.2652 14 21 14ZM12 6C11.2044 6 10.4413 6.31607 9.87868 6.87868C9.31607 7.44129 9 8.20435 9 9V10C8.46957 10 7.96086 10.2107 7.58579 10.5858C7.21071 10.9609 7 11.4696 7 12V16C7 16.5304 7.21071 17.0391 7.58579 17.4142C7.96086 17.7893 8.46957 18 9 18H15C15.5304 18 16.0391 17.7893 16.4142 17.4142C16.7893 17.0391 17 16.5304 17 16V12C17 11.4696 16.7893 10.9609 16.4142 10.5858C16.0391 10.2107 15.5304 10 15 10V9C15 8.20435 14.6839 7.44129 14.1213 6.87868C13.5587 6.31607 12.7956 6 12 6ZM11 9C11 8.73478 11.1054 8.48043 11.2929 8.29289C11.4804 8.10536 11.7348 8 12 8C12.2652 8 12.5196 8.10536 12.7071 8.29289C12.8946 8.48043 13 8.73478 13 9V10H11V9ZM15 16H9V12H15V16ZM3 10C3.26522 10 3.51957 9.89464 3.70711 9.70711C3.89464 9.51957 4 9.26522 4 9V4H9C9.26522 4 9.51957 3.89464 9.70711 3.70711C9.89464 3.51957 10 3.26522 10 3C10 2.73478 9.89464 2.48043 9.70711 2.29289C9.51957 2.10536 9.26522 2 9 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V9C2 9.26522 2.10536 9.51957 2.29289 9.70711C2.48043 9.89464 2.73478 10 3 10ZM9 20H4V15C4 14.7348 3.89464 14.4804 3.70711 14.2929C3.51957 14.1054 3.26522 14 3 14C2.73478 14 2.48043 14.1054 2.29289 14.2929C2.10536 14.4804 2 14.7348 2 15V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H9C9.26522 22 9.51957 21.8946 9.70711 21.7071C9.89464 21.5196 10 21.2652 10 21C10 20.7348 9.89464 20.4804 9.70711 20.2929C9.51957 20.1054 9.26522 20 9 20Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: false,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.system_access_add,
        edit: Path.system_accessedit,
        view: Path.system_accessview,
      },
    },
    /*************Content Pages********/
    {
      url: Path.content_pages,
      model_name: "content_pages",
      name: "Content Pages",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M19 20H5V4H7V7H17V4H19M12 2C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3C13 3.26522 12.8946 3.51957 12.7071 3.70711C12.5196 3.89464 12.2652 4 12 4C11.7348 4 11.4804 3.89464 11.2929 3.70711C11.1054 3.51957 11 3.26522 11 3C11 2.73478 11.1054 2.48043 11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2ZM19 2H14.82C14.4 0.84 13.3 0 12 0C10.7 0 9.6 0.84 9.18 2H5C4.46957 2 3.96086 2.21071 3.58579 2.58579C3.21071 2.96086 3 3.46957 3 4V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V4C21 3.46957 20.7893 2.96086 20.4142 2.58579C20.0391 2.21071 19.5304 2 19 2Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.content_add,
        edit: Path.contentedit,
      },
    },
    /*************Manage Notification********/
    // {
    //   url: Path.notification,
    //   model_name: "notification",
    //   name: "Notification",
    //   sidebar_icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //     >
    //       <path
    //         d="M6.14 14.9693L8.968 17.7973C8.78351 17.9883 8.56282 18.1407 8.31881 18.2455C8.0748 18.3503 7.81236 18.4055 7.5468 18.4078C7.28124 18.4101 7.01788 18.3595 6.77209 18.2589C6.5263 18.1584 6.303 18.0099 6.11521 17.8221C5.92742 17.6343 5.77892 17.411 5.67836 17.1652C5.57779 16.9194 5.52719 16.656 5.5295 16.3905C5.53181 16.1249 5.58698 15.8625 5.6918 15.6185C5.79662 15.3745 5.94898 15.1538 6.14 14.9693ZM15.007 20.2943L14.301 21.0003L3 9.69929L3.706 8.99329L4.808 9.15029C5.562 9.25829 6.497 9.02829 6.885 8.64029L10.77 4.75629C11.8975 3.65 13.4161 3.03359 14.9957 3.04108C16.5753 3.04858 18.088 3.67939 19.205 4.79632C20.3219 5.91326 20.9527 7.426 20.9602 9.00557C20.9677 10.5851 20.3513 12.1038 19.245 13.2313L15.36 17.1163C14.972 17.5043 14.742 18.4393 14.85 19.1933L15.007 20.2943Z"
    //         fill="white"
    //       />
    //     </svg>
    //   ),
    //   icon: "far fa fa-user",
    //   dashboard: false,
    //   is_modules: true,
    //   is_permission: true,
    //   is_sidebar: true,
    //   is_dropdown: false,
    //   is_open: false,
    //   count: 0,
    //   sub_modules: {
    //     form: Path.notification_add,
    //     // edit: Path.subcategoryedit,
    //     // view: Path.subcategoryview,
    //   },
    // },

    /*************Email Template********/
    {
      url: Path.email_template,
      model_name: "emailtemplate",
      name: "Email Template",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M19 14.5V5.5C19 4.67 18.33 4 17.5 4H3.48999C2.65999 4 1.98999 4.67 1.98999 5.5V14.5C1.98999 15.33 2.65999 16 3.48999 16H17.5C18.33 16 19 15.33 19 14.5ZM17.69 5.39C18.02 5.72 17.84 6.06 17.66 6.23L13.6 9.95L17.5 14.01C17.62 14.15 17.7 14.37 17.56 14.52C17.43 14.68 17.13 14.67 17 14.57L12.63 10.84L10.49 12.79L8.35999 10.84L3.98999 14.57C3.85999 14.67 3.55999 14.68 3.42999 14.52C3.28999 14.37 3.36999 14.15 3.48999 14.01L7.38999 9.95L3.32999 6.23C3.14999 6.06 2.96999 5.72 3.29999 5.39C3.62999 5.06 3.96999 5.22 4.24999 5.46L10.49 10.5L16.74 5.46C17.02 5.22 17.36 5.06 17.69 5.39Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: false,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0,
      sub_modules: {
        edit: Path.email_template__edit,
      },
    },
    /*************Configuration********/
    {
      url: Path.configuration,
      model_name: "configuration",
      name: "Configuration",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
        >
          <path
            d="M15.0139 6.51813H14.9451C14.8442 6.51724 14.7459 6.48598 14.663 6.42842C14.5801 6.37086 14.5165 6.28967 14.4804 6.19544C14.4424 6.10444 14.4323 6.00419 14.4515 5.90746C14.4707 5.81073 14.5182 5.72189 14.588 5.65223L14.6369 5.60329C14.9319 5.30713 15.0976 4.90614 15.0976 4.48811C15.0976 4.07008 14.9319 3.66908 14.6369 3.37293L13.8242 2.56081C13.5283 2.26556 13.1274 2.09974 12.7093 2.09974C12.2913 2.09974 11.8903 2.26556 11.5944 2.56081L11.5455 2.60975C11.4734 2.67919 11.3826 2.72607 11.2842 2.74464C11.1858 2.76321 11.0842 2.75266 10.9917 2.71428C10.8993 2.67591 10.82 2.61137 10.7637 2.5286C10.7074 2.44583 10.6765 2.34843 10.6747 2.24833V2.17896C10.6743 1.76087 10.508 1.36002 10.2124 1.06439C9.91677 0.768753 9.51593 0.602478 9.09784 0.602051H7.94904C7.53095 0.602478 7.13011 0.768753 6.83447 1.06439C6.53884 1.36002 6.37256 1.76087 6.37214 2.17896V2.24833C6.36951 2.34771 6.33814 2.44419 6.28182 2.5261C6.22549 2.60801 6.14663 2.67184 6.05478 2.70986C5.96293 2.74787 5.86202 2.75845 5.76429 2.7403C5.66655 2.72215 5.57617 2.67606 5.50409 2.6076L5.45783 2.55866C5.16191 2.26341 4.76095 2.09759 4.34292 2.09759C3.92489 2.09759 3.52393 2.26341 3.22801 2.55866L2.41266 3.37078C2.11764 3.66693 1.95199 4.06793 1.95199 4.48596C1.95199 4.90399 2.11764 5.30498 2.41266 5.60114L2.46161 5.65008C2.53209 5.72219 2.57927 5.81383 2.59701 5.9131C2.61475 6.01236 2.60224 6.11467 2.5611 6.20673C2.5242 6.29843 2.46078 6.37704 2.37897 6.43251C2.29715 6.48798 2.20065 6.51779 2.1018 6.51813H2.03296C1.61487 6.51856 1.21403 6.68483 0.918391 6.98047C0.622757 7.2761 0.456482 7.67695 0.456055 8.09504V9.24383C0.456482 9.66192 0.622757 10.0628 0.918391 10.3584C1.21403 10.654 1.61487 10.8203 2.03296 10.8207H2.1018C2.20271 10.8216 2.301 10.8529 2.38389 10.9104C2.46677 10.968 2.5304 11.0492 2.56648 11.1434C2.60447 11.2344 2.61453 11.3347 2.59537 11.4314C2.57622 11.5281 2.52872 11.617 2.45892 11.6866L2.40997 11.7356C2.11495 12.0317 1.9493 12.4327 1.9493 12.8508C1.9493 13.2688 2.11495 13.6698 2.40997 13.9659L3.22209 14.7775C3.51797 15.0731 3.91907 15.2391 4.33727 15.2391C4.75548 15.2391 5.15658 15.0731 5.45245 14.7775L5.5014 14.7286C5.57355 14.6582 5.66518 14.611 5.76443 14.5933C5.86368 14.5755 5.96597 14.588 6.05805 14.6291C6.14974 14.6658 6.22838 14.7291 6.28386 14.8109C6.33934 14.8926 6.36914 14.9891 6.36945 15.0878V15.1572C6.3693 15.3647 6.41007 15.5702 6.4894 15.7619C6.56873 15.9536 6.68508 16.1278 6.83178 16.2745C6.97849 16.4212 7.15268 16.5375 7.34439 16.6169C7.5361 16.6962 7.74157 16.737 7.94904 16.7368H9.09784C9.51593 16.7364 9.91677 16.5701 10.2124 16.2745C10.508 15.9788 10.6743 15.578 10.6747 15.1599V15.0905C10.6774 14.9912 10.7087 14.8947 10.7651 14.8128C10.8214 14.7309 10.9002 14.667 10.9921 14.629C11.0839 14.591 11.1849 14.5804 11.2826 14.5986C11.3803 14.6167 11.4707 14.6628 11.5428 14.7313L11.5917 14.7802C11.8877 15.0755 12.2886 15.2413 12.7066 15.2413C13.1247 15.2413 13.5256 15.0755 13.8216 14.7802L14.6342 13.9686C14.9292 13.6725 15.0949 13.2715 15.0949 12.8534C15.0949 12.4354 14.9292 12.0344 14.6342 11.7383L14.5853 11.6893C14.5148 11.6172 14.4676 11.5256 14.4499 11.4263C14.4321 11.327 14.4446 11.2247 14.4858 11.1327C14.5226 11.0409 14.586 10.9622 14.6678 10.9066C14.7496 10.851 14.8462 10.8211 14.9451 10.8207H15.0139C15.432 10.8203 15.8328 10.654 16.1285 10.3584C16.4241 10.0628 16.5904 9.66192 16.5908 9.24383V8.09504C16.5904 7.67695 16.4241 7.2761 16.1285 6.98047C15.8328 6.68483 15.432 6.51856 15.0139 6.51813ZM15.5152 9.24383C15.515 9.37673 15.4622 9.50414 15.3682 9.59811C15.2742 9.69209 15.1468 9.74494 15.0139 9.74508H14.9451C14.633 9.74774 14.3286 9.84221 14.0698 10.0167C13.811 10.1912 13.6093 10.438 13.4898 10.7264C13.3704 11.0147 13.3384 11.3318 13.398 11.6382C13.4576 11.9446 13.606 12.2267 13.8248 12.4493L13.8732 12.4982C13.9671 12.5924 14.0198 12.7199 14.0198 12.8529C14.0198 12.9859 13.9671 13.1134 13.8732 13.2076L13.0605 14.0192C12.9665 14.1132 12.839 14.166 12.7061 14.166C12.5732 14.166 12.4457 14.1132 12.3517 14.0192L12.3033 13.9702C12.0806 13.7517 11.7985 13.6035 11.4922 13.5441C11.1859 13.4847 10.8689 13.5167 10.5807 13.6361C10.2924 13.7555 10.0457 13.9571 9.87114 14.2157C9.6966 14.4743 9.60199 14.7785 9.59909 15.0905V15.1599C9.59895 15.2928 9.54609 15.4202 9.45212 15.5142C9.35814 15.6082 9.23073 15.661 9.09784 15.6612H7.94904C7.81614 15.661 7.68873 15.6082 7.59476 15.5142C7.50078 15.4202 7.44793 15.2928 7.44779 15.1599V15.0905C7.44628 14.7779 7.35247 14.4727 7.17814 14.2132C7.00381 13.9537 6.75673 13.7514 6.46788 13.6318C6.17904 13.5122 5.86131 13.4806 5.55455 13.5409C5.24779 13.6012 4.96568 13.7507 4.7436 13.9708L4.69466 14.0197C4.60052 14.1135 4.47308 14.1661 4.34023 14.1661C4.20738 14.1661 4.07995 14.1135 3.9858 14.0197L3.17369 13.2081C3.07979 13.114 3.02706 12.9864 3.02706 12.8534C3.02706 12.7205 3.07979 12.5929 3.17369 12.4988L3.22263 12.4498C3.44163 12.2272 3.59022 11.945 3.64987 11.6385C3.70952 11.332 3.67758 11.0147 3.55803 10.7262C3.43849 10.4377 3.23663 10.1909 2.97766 10.0164C2.71868 9.84189 2.41406 9.74753 2.1018 9.74508H2.03296C1.90006 9.74494 1.77265 9.69209 1.67868 9.59811C1.5847 9.50414 1.53185 9.37673 1.53171 9.24383V8.09504C1.53185 7.96214 1.5847 7.83473 1.67868 7.74075C1.77265 7.64678 1.90006 7.59392 2.03296 7.59378H2.1018C2.41391 7.59113 2.71832 7.49666 2.9771 7.32216C3.23588 7.14767 3.43758 6.90086 3.55703 6.61251C3.67649 6.32416 3.70843 6.00702 3.64887 5.70064C3.58931 5.39426 3.44088 5.11219 3.22209 4.8896L3.17369 4.84065C3.07982 4.74658 3.02711 4.61912 3.02711 4.48623C3.02711 4.35334 3.07982 4.22587 3.17369 4.1318L3.9858 3.31915C4.07981 3.22515 4.2073 3.17234 4.34023 3.17234C4.47317 3.17234 4.60066 3.22515 4.69466 3.31915L4.74306 3.36809C4.96569 3.58677 5.24774 3.73512 5.55408 3.79466C5.86042 3.8542 6.1775 3.8223 6.46584 3.70293C6.75417 3.58356 7.00102 3.382 7.17562 3.12335C7.35023 2.8647 7.44488 2.56039 7.44779 2.24833V2.17896C7.44793 2.04606 7.50078 1.91865 7.59476 1.82467C7.68873 1.7307 7.81614 1.67784 7.94904 1.6777H9.09784C9.23073 1.67784 9.35814 1.7307 9.45212 1.82467C9.54609 1.91865 9.59895 2.04606 9.59909 2.17896V2.24833C9.60185 2.56039 9.69639 2.86474 9.87093 3.12344C10.0455 3.38214 10.2923 3.58375 10.5806 3.70314C10.8689 3.82253 11.186 3.85442 11.4924 3.79484C11.7987 3.73526 12.0807 3.58685 12.3033 3.36809L12.3522 3.31915C12.4462 3.22515 12.5737 3.17234 12.7066 3.17234C12.8396 3.17234 12.9671 3.22515 13.0611 3.31915L13.8732 4.1318C13.9671 4.22587 14.0198 4.35334 14.0198 4.48623C14.0198 4.61912 13.9671 4.74658 13.8732 4.84065L13.8242 4.8896C13.6054 5.11222 13.457 5.39434 13.3974 5.70077C13.3379 6.0072 13.3699 6.32438 13.4894 6.61275C13.6089 6.90112 13.8107 7.14793 14.0696 7.32238C14.3284 7.49684 14.6329 7.59123 14.9451 7.59378H15.0139C15.1468 7.59392 15.2742 7.64678 15.3682 7.74075C15.4622 7.83473 15.515 7.96214 15.5152 8.09504V9.24383Z"
            fill="white"
          ></path>
          <path
            d="M8.52333 4.90479C7.77872 4.90479 7.05084 5.12559 6.43173 5.53926C5.81261 5.95294 5.33007 6.54092 5.04512 7.22885C4.76018 7.91677 4.68562 8.67374 4.83089 9.40404C4.97615 10.1343 5.33471 10.8052 5.86122 11.3317C6.38774 11.8582 7.05856 12.2167 7.78885 12.362C8.51915 12.5073 9.27612 12.4327 9.96404 12.1478C10.652 11.8628 11.2399 11.3803 11.6536 10.7612C12.0673 10.142 12.2881 9.41417 12.2881 8.66956C12.287 7.67143 11.89 6.71451 11.1842 6.00872C10.4784 5.30293 9.52146 4.90592 8.52333 4.90479ZM8.52333 11.3587C7.99147 11.3587 7.47155 11.201 7.02933 10.9055C6.5871 10.61 6.24243 10.19 6.03889 9.69865C5.83536 9.20727 5.78211 8.66658 5.88587 8.14494C5.98963 7.6233 6.24574 7.14414 6.62182 6.76806C6.99791 6.39198 7.47706 6.13587 7.9987 6.03211C8.52034 5.92835 9.06104 5.9816 9.55241 6.18513C10.0438 6.38867 10.4638 6.73334 10.7593 7.17556C11.0547 7.61779 11.2125 8.1377 11.2125 8.66956C11.2116 9.3825 10.928 10.066 10.4239 10.5701C9.91976 11.0742 9.23626 11.3578 8.52333 11.3587Z"
            fill="white"
          ></path>
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: false,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: true,
      is_open: false,
      count: 0,
      sub_modules: {
        settings: Path.configuration,
        permissions: Path.instance_permissions,
      },
      dropdown_module: [
        {
          url: Path.configuration,
          model_name: "settings",
          name: "Settings",
          sidebar_icon: "fas fa-fire",
          icon: "far fa fa-user",
          dashboard: false,
          is_modules: false,
          is_permission: true,
          is_sidebar: false,
          is_dropdown: false,
          is_open: false,
          count: 0,
          sub_modules: {},
        },
        {
          url: Path.instance_permissions,
          model_name: "instance_permissions",
          name: "Permissions",
          sidebar_icon: "fas fa-fire",
          icon: "far fa fa-user",
          dashboard: false,
          is_modules: false,
          is_permission: true,
          is_sidebar: false,
          is_dropdown: false,
          is_open: false,
          count: 0,
          sub_modules: {},
        },
      ],
    },
    /*************Help Pages********/
    {
      url: Path.help_pages,
      model_name: "help_pages",
      name: "Help Pages",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M19 20H5V4H7V7H17V4H19M12 2C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3C13 3.26522 12.8946 3.51957 12.7071 3.70711C12.5196 3.89464 12.2652 4 12 4C11.7348 4 11.4804 3.89464 11.2929 3.70711C11.1054 3.51957 11 3.26522 11 3C11 2.73478 11.1054 2.48043 11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2ZM19 2H14.82C14.4 0.84 13.3 0 12 0C10.7 0 9.6 0.84 9.18 2H5C4.46957 2 3.96086 2.21071 3.58579 2.58579C3.21071 2.96086 3 3.46957 3 4V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V4C21 3.46957 20.7893 2.96086 20.4142 2.58579C20.0391 2.21071 19.5304 2 19 2Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: true,
      is_open: false,
      count: 0,
      sub_modules: {
        form: Path.help_pages_add,
        edit: Path.help_pages_edit,
      },
      dropdown_module: [
        {
          url: Path.help_pages,
          model_name: "help_pages",
          name: "All Pages",
          sidebar_icon: "fas fa-plus",
          icon: "far fa fa-plus",
          dashboard: false,
          is_modules: false,
          is_permission: true,
          is_sidebar: false,
          is_dropdown: false,
          is_open: false,
          count: 0,
          sub_modules: {},
        },
        {
          url: Path.help_pages_add,
          model_name: "help_pages_add",
          name: "Add New Page",
          sidebar_icon: "fas fa-plus",
          icon: "far fa fa-plus",
          dashboard: false,
          is_modules: false,
          is_permission: true,
          is_sidebar: false,
          is_dropdown: false,
          is_open: false,
          count: 0,
          sub_modules: {},
        }
      ]
    },

    /**
     * Manage banners
     */
    {
      url: Path.banner_management,
      model_name: "banner_management",
      name: "Banner Management",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
        >
          <path
            d="M17.8389 1.89209C17.4131 1.46545 16.847 1.23047 16.2446 1.23047H15.2271V1.02539C15.2271 0.45999 14.7671 0 14.2017 0H6.81885C6.25345 0 5.79346 0.45999 5.79346 1.02539V1.23047H4.77229C3.53112 1.23047 2.52021 2.24134 2.51881 3.48383L2.50195 18.7416C2.5013 19.3447 2.73537 19.9117 3.16108 20.3384C3.58682 20.765 4.15304 21 4.75543 21H16.2277C17.4689 21 18.4798 19.9891 18.4812 18.7466L18.498 3.48883C18.4987 2.88578 18.2646 2.3187 17.8389 1.89209ZM7.02393 1.23047H13.9966V2.46094H7.02393V1.23047ZM17.252 18.7452C17.2513 19.3101 16.7918 19.7695 16.2277 19.7695H4.75543C4.48161 19.7695 4.22424 19.6627 4.03073 19.4688C3.83722 19.2748 3.73082 19.0171 3.73111 18.743L3.74797 3.48522C3.74858 2.92039 4.20808 2.46094 4.77229 2.46094H5.79346V2.66602C5.79346 3.23142 6.25345 3.69141 6.81885 3.69141H14.2017C14.7671 3.69141 15.2271 3.23142 15.2271 2.66602V2.46094H16.2446C16.5184 2.46094 16.7758 2.56774 16.9693 2.76166C17.1628 2.95559 17.2692 3.21337 17.2689 3.48744L17.252 18.7452Z"
            fill="white"
          />
          <path
            d="M10.7091 8.20305H15.0802C15.42 8.20305 15.6954 7.92759 15.6954 7.58782C15.6954 7.24805 15.42 6.97259 15.0802 6.97259H10.7091C10.3693 6.97259 10.0939 7.24805 10.0939 7.58782C10.0939 7.92759 10.3693 8.20305 10.7091 8.20305ZM10.7091 12.3046H15.0802C15.42 12.3046 15.6954 12.0292 15.6954 11.6894C15.6954 11.3496 15.42 11.0741 15.0802 11.0741H10.7091C10.3693 11.0741 10.0939 11.3496 10.0939 11.6894C10.0939 12.0292 10.3693 12.3046 10.7091 12.3046ZM15.0978 15.1757H10.7091C10.3693 15.1757 10.0939 15.4512 10.0939 15.7909C10.0939 16.1307 10.3693 16.4062 10.7091 16.4062H15.0978C15.4376 16.4062 15.713 16.1307 15.713 15.7909C15.713 15.4512 15.4376 15.1757 15.0978 15.1757ZM8.09056 5.91262L6.67175 7.33143L6.33722 6.99687C6.09695 6.7566 5.70743 6.7566 5.46716 6.99687C5.22689 7.2371 5.22689 7.62666 5.46716 7.86693L6.23673 8.63655C6.35211 8.75192 6.5086 8.81674 6.67177 8.81674C6.83494 8.81674 6.99142 8.75192 7.1068 8.63655L8.96066 6.78272C9.20093 6.5425 9.20093 6.15293 8.96066 5.91266C8.7204 5.67235 8.33087 5.67235 8.09056 5.91262ZM8.09056 10.3274L6.67175 11.7462L6.33722 11.4117C6.09695 11.1714 5.70743 11.1714 5.46716 11.4117C5.22689 11.6519 5.22689 12.0415 5.46716 12.2818L6.23673 13.0514C6.35211 13.1668 6.5086 13.2316 6.67177 13.2316C6.83494 13.2316 6.99142 13.1668 7.1068 13.0514L8.96066 11.1975C9.20093 10.9573 9.20093 10.5677 8.96066 10.3275C8.7204 10.0872 8.33083 10.0872 8.09056 10.3274ZM8.09056 14.429L6.67175 15.8478L6.33722 15.5133C6.09695 15.273 5.70743 15.273 5.46716 15.5133C5.22689 15.7535 5.22689 16.143 5.46716 16.3833L6.23673 17.1529C6.35211 17.2683 6.5086 17.3331 6.67177 17.3331C6.83494 17.3331 6.99142 17.2683 7.1068 17.1529L8.96066 15.2991C9.20093 15.0589 9.20093 14.6693 8.96066 14.429C8.7204 14.1888 8.33083 14.1888 8.09056 14.429Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: true,
      is_open: false,
      count: 0,
      dropdown_module: [
        {
          url: Path.banner_management,
          model_name: "banner_managements",
          name: "View Banners",
          sidebar_icon: "fas fa-plus",
          icon: "far fa fa-plus",
          dashboard: false,
          is_modules: false,
          is_permission: true,
          is_sidebar: false,
          is_dropdown: false,
          is_open: false,
          count: 0,
          sub_modules: {},
        }
      ]
    },

    /**
     * Manage Announcements
     */
    {
      url: Path.announcements_management,
      model_name: "announcements_management",
      name: "Announcements",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18 15H6L2 19V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H18C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V14C19 14.2652 18.8946 14.5196 18.7071 14.7071C18.5196 14.8946 18.2652 15 18 15ZM23 9V23L19 19H8C7.73478 19 7.48043 18.8946 7.29289 18.7071C7.10536 18.5196 7 18.2652 7 18V17H21V8H22C22.2652 8 22.5196 8.10536 22.7071 8.29289C22.8946 8.48043 23 8.73478 23 9ZM8.19 4C7.32 4 6.62 4.2 6.08 4.59C5.56 5 5.3 5.57 5.31 6.36L5.32 6.39H7.25C7.26 6.09 7.35 5.86 7.53 5.7C7.71517 5.54644 7.9495 5.46479 8.19 5.47C8.5 5.47 8.76 5.57 8.94 5.75C9.12 5.94 9.2 6.2 9.2 6.5C9.2 6.82 9.13 7.09 8.97 7.32C8.83 7.55 8.62 7.75 8.36 7.91C7.85 8.25 7.5 8.55 7.31 8.82C7.11 9.08 7 9.5 7 10H9C9 9.69 9.04 9.44 9.13 9.26C9.22 9.08 9.39 8.9 9.64 8.74C10.09 8.5 10.46 8.21 10.75 7.81C11.04 7.41 11.19 7 11.19 6.5C11.19 5.74 10.92 5.13 10.38 4.68C9.85 4.23 9.12 4 8.19 4ZM7 11V13H9V11H7ZM13 13H15V11H13V13ZM13 4V10H15V4H13Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: true,
      is_open: false,
      count: 0,
      dropdown_module: [
        {
          url: Path.announcements_management,
          model_name: "announcements_management",
          name: "View Announcements",
          sidebar_icon: "fas fa-plus",
          icon: "far fa fa-plus",
          dashboard: false,
          is_modules: false,
          is_permission: true,
          is_sidebar: false,
          is_dropdown: false,
          is_open: false,
          count: 0,
          sub_modules: {},
        }
      ]
    },

    /**
     * Email Logs
     */
    // {
    //   url: Path.email_logs_list,
    //   model_name: "email_logs_list",
    //   name: "Email Logs",
    //   sidebar_icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //     >
    //       <path
    //         d="M18 15H6L2 19V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H18C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V14C19 14.2652 18.8946 14.5196 18.7071 14.7071C18.5196 14.8946 18.2652 15 18 15ZM23 9V23L19 19H8C7.73478 19 7.48043 18.8946 7.29289 18.7071C7.10536 18.5196 7 18.2652 7 18V17H21V8H22C22.2652 8 22.5196 8.10536 22.7071 8.29289C22.8946 8.48043 23 8.73478 23 9ZM8.19 4C7.32 4 6.62 4.2 6.08 4.59C5.56 5 5.3 5.57 5.31 6.36L5.32 6.39H7.25C7.26 6.09 7.35 5.86 7.53 5.7C7.71517 5.54644 7.9495 5.46479 8.19 5.47C8.5 5.47 8.76 5.57 8.94 5.75C9.12 5.94 9.2 6.2 9.2 6.5C9.2 6.82 9.13 7.09 8.97 7.32C8.83 7.55 8.62 7.75 8.36 7.91C7.85 8.25 7.5 8.55 7.31 8.82C7.11 9.08 7 9.5 7 10H9C9 9.69 9.04 9.44 9.13 9.26C9.22 9.08 9.39 8.9 9.64 8.74C10.09 8.5 10.46 8.21 10.75 7.81C11.04 7.41 11.19 7 11.19 6.5C11.19 5.74 10.92 5.13 10.38 4.68C9.85 4.23 9.12 4 8.19 4ZM7 11V13H9V11H7ZM13 13H15V11H13V13ZM13 4V10H15V4H13Z"
    //         fill="white"
    //       />
    //     </svg>
    //   ),
    //   icon: "far fa fa-user",
    //   dashboard: false,
    //   is_modules: true,
    //   is_permission: true,
    //   is_sidebar: true,
    //   is_dropdown: false,
    //   is_open: false,
    //   count: 0
    // },

    /**
     * Account Deletion Requests
     */
    {
      url: Path.account_deletion,
      model_name: "account_deletion",
      name: "Account Deletion Requests",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M16 17.0001V19.0001H2V17.0001C2 17.0001 2 13.0001 9 13.0001C16 13.0001 16 17.0001 16 17.0001ZM12.5 7.50005C12.5 6.80782 12.2947 6.13113 11.9101 5.55556C11.5256 4.97998 10.9789 4.53138 10.3394 4.26647C9.69985 4.00157 8.99612 3.93226 8.31718 4.0673C7.63825 4.20235 7.01461 4.5357 6.52513 5.02518C6.03564 5.51466 5.7023 6.1383 5.56725 6.81724C5.4322 7.49617 5.50152 8.1999 5.76642 8.83944C6.03133 9.47899 6.47993 10.0256 7.0555 10.4102C7.63108 10.7948 8.30777 11.0001 9 11.0001C9.92826 11.0001 10.8185 10.6313 11.4749 9.97493C12.1313 9.31855 12.5 8.42831 12.5 7.50005ZM15.94 13.0001C16.5547 13.4758 17.0578 14.0805 17.4137 14.7716C17.7696 15.4626 17.9697 16.2233 18 17.0001V19.0001H22V17.0001C22 17.0001 22 13.3701 15.94 13.0001ZM15 4.00005C14.3117 3.99622 13.6385 4.20201 13.07 4.59005C13.6774 5.43879 14.0041 6.45634 14.0041 7.50005C14.0041 8.54377 13.6774 9.56132 13.07 10.4101C13.6385 10.7981 14.3117 11.0039 15 11.0001C15.9283 11.0001 16.8185 10.6313 17.4749 9.97493C18.1313 9.31855 18.5 8.42831 18.5 7.50005C18.5 6.57179 18.1313 5.68156 17.4749 5.02518C16.8185 4.3688 15.9283 4.00005 15 4.00005Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0
    },

    /**
     * Audit Logs
     */
    {
      url: Path.audit_logs,
      model_name: "audit_logs",
      name: "Audit Logs",
      sidebar_icon: (
        <svg
          viewBox="0 0 512 512"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          fill="#ffffff"
          stroke="#ffffff"
          transform="matrix(1, 0, 0, 1, 0, 0)"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth={0} />
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
          <g id="SVGRepo_iconCarrier">
            {" "}
            <title>audit-report</title>{" "}
            <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
              {" "}
              <g id="icon" fill="#ffffff" transform="translate(42.665250, 42.666667)">
                {" "}
                <path
                  d="M341.33475,42.6666667 L426.668083,128 L426.668083,384 L0.00141677613,384 L1.36004076e-14,151.329691 C10.0983011,166.682012 24.2153849,184.436546 42.6673443,199.495392 L42.6680834,341.333333 L384.001417,341.333333 L384.001417,138.666667 L330.668083,85.3333333 L290.932237,85.3351205 C285.492739,74.6817682 276.348053,58.8452682 263.198008,42.6667242 L341.33475,42.6666667 Z M341.33475,277.333333 L341.33475,298.666667 L85.3347501,298.666667 L85.3347501,277.333333 L341.33475,277.333333 Z M341.33475,213.333333 L341.33475,234.666667 L213.33475,234.666667 L213.334687,214.29601 C213.875883,213.977904 214.414374,213.65703 214.950164,213.333459 L341.33475,213.333333 Z M138.668083,7.10542736e-15 C235.73475,7.10542736e-15 277.33475,106.666667 277.33475,106.666667 C277.33475,106.666667 235.73475,213.333333 138.668083,213.333333 C41.6014168,213.333333 0.00141677613,106.666667 0.00141677613,106.666667 C0.00141677613,106.666667 41.6014168,7.10542736e-15 138.668083,7.10542736e-15 Z M138.668083,26.6666667 C77.3774168,26.6666667 41.6014168,83.7333333 30.3694168,106.666667 C41.6014168,129.6 77.3774168,186.666667 138.668083,186.666667 C199.95875,186.666667 235.73475,129.6 246.96675,106.666667 C235.73475,83.7333333 199.95875,26.6666667 138.668083,26.6666667 Z M138.668083,60 C165.472303,60 187.201417,80.8933783 187.201417,106.666667 C187.201417,132.439955 165.472303,153.333333 138.668083,153.333333 C111.863864,153.333333 90.1347501,132.439955 90.1347501,106.666667 C90.1347501,80.8933783 111.863864,60 138.668083,60 Z M138.668083,86.6666667 C127.180561,86.6666667 117.868083,95.6209717 117.868083,106.666667 C117.868083,117.712362 127.180561,126.666667 138.668083,126.666667 C150.155606,126.666667 159.468083,117.712362 159.468083,106.666667 C159.468083,95.6209717 150.155606,86.6666667 138.668083,86.6666667 Z"
                  id="Combined-Shape"
                >
                  {" "}
                </path>{" "}
              </g>{" "}
            </g>{" "}
          </g>
        </svg>

      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0
    },

    /**
     * Account Deletion Requests
     */
    {
      url: Path.email_subscription_modules,
      model_name: "email_subscription_modules",
      name: "Manage Email Preferences",
      sidebar_icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M16 17.0001V19.0001H2V17.0001C2 17.0001 2 13.0001 9 13.0001C16 13.0001 16 17.0001 16 17.0001ZM12.5 7.50005C12.5 6.80782 12.2947 6.13113 11.9101 5.55556C11.5256 4.97998 10.9789 4.53138 10.3394 4.26647C9.69985 4.00157 8.99612 3.93226 8.31718 4.0673C7.63825 4.20235 7.01461 4.5357 6.52513 5.02518C6.03564 5.51466 5.7023 6.1383 5.56725 6.81724C5.4322 7.49617 5.50152 8.1999 5.76642 8.83944C6.03133 9.47899 6.47993 10.0256 7.0555 10.4102C7.63108 10.7948 8.30777 11.0001 9 11.0001C9.92826 11.0001 10.8185 10.6313 11.4749 9.97493C12.1313 9.31855 12.5 8.42831 12.5 7.50005ZM15.94 13.0001C16.5547 13.4758 17.0578 14.0805 17.4137 14.7716C17.7696 15.4626 17.9697 16.2233 18 17.0001V19.0001H22V17.0001C22 17.0001 22 13.3701 15.94 13.0001ZM15 4.00005C14.3117 3.99622 13.6385 4.20201 13.07 4.59005C13.6774 5.43879 14.0041 6.45634 14.0041 7.50005C14.0041 8.54377 13.6774 9.56132 13.07 10.4101C13.6385 10.7981 14.3117 11.0039 15 11.0001C15.9283 11.0001 16.8185 10.6313 17.4749 9.97493C18.1313 9.31855 18.5 8.42831 18.5 7.50005C18.5 6.57179 18.1313 5.68156 17.4749 5.02518C16.8185 4.3688 15.9283 4.00005 15 4.00005Z"
            fill="white"
          />
        </svg>
      ),
      icon: "far fa fa-user",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0
    },

    {
      url: Path.trash_bin,
      model_name: "trash_bin",
      name: "Trash Bin",
      sidebar_icon: (
        <i className="fa fa-lg fa-trash" aria-hidden="true"></i>
      ),
      icon: "far fa fa-bin",
      dashboard: false,
      is_modules: true,
      is_permission: true,
      is_sidebar: true,
      is_dropdown: false,
      is_open: false,
      count: 0
    },
  ];
  return modules;
};

export { useModules };
